import React, { useState } from "react";
import multi from "./MultiSelect.module.css";
import { HiX } from "react-icons/hi";
import DashboardStyle from "../../Styles/Dashboard.module.css";
import { useFormContext } from "react-hook-form";
import ClickAwayListener from "../Misc/ClickAwayListener";

const MultiSelect = ({ data, dataValues, title, name, isOptional }) => {
  const { setValue } = useFormContext();
  console.log('data values', dataValues)
  const dataValue = Array.isArray(dataValues) ? dataValues : [dataValues]
  const [showOptions, setShowOptions] = useState(false);
  const thirdArray = data?.filter?.((elem) => {
    const tv = dataValue?.some?.((ele) => {
      return +ele === elem?.id;
    });
    return tv;
  });

  const removeFromThirdArray = (id) => {
    const newArray = thirdArray?.filter((elem) => {
      return elem?.id !== id;
    });

    return setValue(
      name,
      newArray?.map((x) => x?.id?.toString())
    );
  };

  const itemsDisplay = 2;
  const remainingItemCount = thirdArray ? Math.max(thirdArray.length - itemsDisplay, 0) : 0;
console.log('thirdArray', thirdArray)
  return (
    <ClickAwayListener
      onClickAway={() => setShowOptions(false)}
      className={multi.select}
    >
      <label htmlFor="">
        {title}{" "}
        {isOptional === true ? "" : <sup style={{ color: "red" }}>*</sup>}
      </label>
      <div className={multi.select_choices}>
        {thirdArray?.slice(0, itemsDisplay).map((x) => (
          <button key={x.id} onClick={() => setShowOptions(!showOptions)} type="button">
            <p>{x?.checkBoxName}</p>{" "}
            <HiX
              onClick={(e) => {
                e.stopPropagation();
                removeFromThirdArray(x?.id);
              }}
            />
          </button>
        ))}

        {remainingItemCount > 0 && (
          <button
            className={multi._count}
            onClick={() => setShowOptions(!showOptions)}
            type="button"
          >
            <p>+ {remainingItemCount}</p>
          </button>
        )}
      </div>
      <div
        onClick={() => setShowOptions(!showOptions)}
        className={multi.input_field}
      ></div>

      {showOptions && (
        <div
          style={{ width: "100%" }}
          className={`${DashboardStyle.inputs_group_no_grid} ${multi.inputs_group_no_grid}`}
        >
          <div
            style={{ margin: "0" }}
            className={`${DashboardStyle.inputs_checkbox_groups} ${multi.inputs_checkbox_groups}`}
          >
            <div
              style={{
                margin: "0",
              }}
              className={multi.inputs_checkbox_groupsx}
            >
              {data?.map((x, index) => (
                <MultiCheckBox
                  key={index}
                  name={x?.checkBoxName}
                  camelCase={name}
                  group={name}
                  value={x?.id}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </ClickAwayListener>
  );
}

export default MultiSelect;

export function MultiCheckBox({
  name,
  isHeading,
  camelCase,
  group,
  value,
  moreRegister,
  style,
  isRequired,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // console.log({ camelCase, value, moreRegister, name, group });
  // const inputName = camelCase?.replace(/"/g, "");

  return (
    <div style={{ ...style }} className={DashboardStyle.checkbox_style}>
      <label
        style={{
          fontWeight: isHeading === true && "500",
          marginBottom: isHeading === true ? "40px" : "0.8rem",
        }}
        htmlFor={value}
      >
        {" "}
        <input
          id={value}
          {...register(`${camelCase}`, {
            required: {
              value: isRequired === false ? false : true,
              message: "yeah",
            },
            // onChange: (e) => console.log("name"),
            ...moreRegister,
          })}
          value={value}
          // value={`${value}`}
          name={group || ""}
          type="checkbox"
        />
        {name || ""}
      </label>
      {/* {(errors || errors?.[inputName]) && (
        <small className={input.form__error__message}>
          {errors?.[inputName]?.message}
        </small>
      )} */}
    </div>
  );
}